import React from 'react';

import styled from 'styled-components';

// hooks
import useBetaMode from '../../hooks/helper/useBetaMode';

interface BetaModeProps {
    fallback?: React.ReactElement | null;
    className?: string;
}

const BetaMode: React.FC<React.PropsWithChildren<BetaModeProps>> = ({
    children,
    fallback,
    className,
}) => {
    const { active } = useBetaMode();

    if (!active) return fallback || null;

    return <BetaWrapper className={className}>{children}</BetaWrapper>;
};

export default BetaMode;

const BetaWrapper = styled.div({
    width: '100%',
    height: '100%',
});
